import { tap } from 'ramda'

export const log = tap(console.log)
